import { takeLatest, put, call } from 'redux-saga/effects';
import {
    SEARCH_PORTFOLIO,
    searchPortfolioSuccess,
    searchPortfolioFailure,
    FETCH_RISK_LEVELS,
    fetchRiskLevelsSuccess,
    fetchRiskLevelsFailure,
    FETCH_LEGALCONSTITUTION,
    fetchLegalConstitutionFilterSuccess,
    fetchLegalConstitutionFilterFailure,
    FETCH_BUSINESS_SEGMENT,
    fetchBusinessSegmentFilterSuccess,
    fetchBusinessSegmentFilterFailure,
    FETCH_CASE_STATUS,
    fetchCaseStatusFilterSuccess,
    fetchCaseStatusFilterFailure,
    FETCH_RISK_TREND,
    fetchRiskScoreTrendFilterSuccess,
    fetchRiskScoreTrendFilterFailure,
    FETCH_PRODUCT_NAME_FILTER_LIST,
    fetchProductNameFilterListSuccess,
    fetchProductNameFilterListFailure,
    FETCH_PRODUCT_TYPE_DETAILS,
    fetchProductTypeDetailsSuccess,
    fetchProductTypeDetailsFailure,
    FETCH_CUG_CORPORATE_DATA,
    fetchCugCorpDataSuccess,
    fetchCugCorpDataFailure,
    FETCH_CASE_TYPE,
    fetchCaseTypeSuccess,
    fetchCaseTypeFailure
} from './action';
import { CORE_API, SCORE_DEFINATION, REPORT } from '../../config';
import { HTTP_HEADERS } from '../../constants'
import request from "../../components/Utils/httpHelper";

//Fetch Risk Level Filter List

export function* riskLevelsFetch(action) {
    let requestURL = `${SCORE_DEFINATION}/scorecard/risklevels`;
    try {
        const riskLevelData = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchRiskLevelsSuccess(riskLevelData.data))
    }
    catch (err) {
        yield put(fetchRiskLevelsFailure(err))
    }
}
export function* fetchRiskLevels() {
    yield takeLatest(FETCH_RISK_LEVELS, riskLevelsFetch);
}

//Fetch Risk Trend Filter List
export function* riskTrendFetch(action) {
    let requestURL = `${CORE_API}/portfolio/filter/riskscoretrend`;
    try {
        const riskTrendData = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchRiskScoreTrendFilterSuccess(riskTrendData.data))
    }
    catch (err) {
        yield put(fetchRiskScoreTrendFilterFailure(err))
    }
}
export function* fetchRiskTrend() {
    yield takeLatest(FETCH_RISK_TREND, riskTrendFetch);
}

//Fetch Product Name Filter List
export function* productListFetch(action) {
    let requestURL = `${CORE_API}/portfolio/filter/product`;
    try {
        const productNameData = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchProductNameFilterListSuccess(productNameData.data))
    }
    catch (err) {
        yield put(fetchProductNameFilterListFailure(err))
    }
}
export function* fetchProductList() {
    yield takeLatest(FETCH_PRODUCT_NAME_FILTER_LIST, productListFetch);
}

//Fetch Business Segment Filter List
export function* businessSegmentFetch(action) {
    let requestURL = `${CORE_API}/portfolio/filter/businesssegment`;
    try {
        const businessSegment = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchBusinessSegmentFilterSuccess(businessSegment.data))
    }
    catch (err) {
        yield put(fetchBusinessSegmentFilterFailure(err))
    }
}
export function* fetchBusinessSegment() {
    yield takeLatest(FETCH_BUSINESS_SEGMENT, businessSegmentFetch);
}

//Fetch Legal Constitution Filter List
export function* legalConstitutionFetch(action) {
    let requestURL = `${CORE_API}/portfolio/filter/legalconstitution`;
    try {
        const legalConstitution = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchLegalConstitutionFilterSuccess(legalConstitution.data))
    }
    catch (err) {
        yield put(fetchLegalConstitutionFilterFailure(err))
    }
}
export function* fetchLegalConstitution() {
    yield takeLatest(FETCH_LEGALCONSTITUTION, legalConstitutionFetch);
}

// Fetch Case Status Filter List
export function* casefilterListFetch(action) {
    let requestURL = `${CORE_API}/portfolio/filter/casestatus`;
    try {
        const caseStatusData = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchCaseStatusFilterSuccess(caseStatusData.data))
    }
    catch (err) {
        yield put(fetchCaseStatusFilterFailure(err))
    }
}
export function* fetchCaseStatus() {
    yield takeLatest(FETCH_CASE_STATUS, casefilterListFetch);
}

/* export function* fetchPortfolio(action) {
    let requestURL = `${CORE_API}/portfolio/0/1/sort/riskScore/desc`;
    try {
        const portfolioResult = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchPortfolioDetailsSuccess(portfolioResult.data))
    }
    catch (err) {
        yield put(fetchPortfolioDetailsFailure(err))
    }
}
export function* fetchPortfolioDetails() {
    yield takeLatest(FETCH_PORTFOLIO_DETAILS, fetchPortfolio);
} */

export function* searchPortfolio(action) {
    let requestURL = `${CORE_API}/portfolio/${action.data.paginateData.pageNo}/${action.data.paginateData.pageSize}/sort/${action.data.paginateData.sortField}/${action.data.paginateData.sortType}`;
    try {
        const portfolioResult = yield call(request, requestURL, { method: 'POST', data: action.data.requestData, headers: HTTP_HEADERS });
        yield put(searchPortfolioSuccess(portfolioResult.data))
    }
    catch (err) {
        yield put(searchPortfolioFailure(err))
    }
}
export function* searchPortfolioList() {
    yield takeLatest(SEARCH_PORTFOLIO, searchPortfolio);
}

export function* fecthProductDescription(action) {
    let requestURL = `${REPORT}/product/list/corporate`;
    try {
        const productDescriptionDetails = yield call(request, requestURL, { method: 'GET', data: action.data, headers: HTTP_HEADERS });
        yield put(fetchProductTypeDetailsSuccess(productDescriptionDetails.data))
    }
    catch (err) {
        yield put(fetchProductTypeDetailsFailure(err))
    }
}
export function* getProductDescription() {
    yield takeLatest(FETCH_PRODUCT_TYPE_DETAILS, fecthProductDescription);
}

/* export function* legalConstitutionFetch(action) {
    let requestURL = `${REPORT}/computedscorecard/5bf130578773ac47f6621102`;
    try {
        const legalConstitution = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS ,responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER});
        // yield put(fetchLegalConstitutionFilterSuccess(legalConstitution.data))
        var blob = new Blob([legalConstitution.data], { type: 'application/octet-stream' });
        fileSaver.saveAs(blob, '_survey.xlsx');
    }
    catch (err) {
        yield put(fetchLegalConstitutionFilterFailure(err))
    }
} */

export function* fetchCugCorporateData(action) {
    let requestURL = `${CORE_API}/cug/corporateData/${action.data}`;
    try {
        const cugCorporateData = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchCugCorpDataSuccess(cugCorporateData.data))
    }
    catch (err) {
        yield put(fetchCugCorpDataFailure(err))
    }
}
export function* getCugCorpData() {
    yield takeLatest(FETCH_CUG_CORPORATE_DATA, fetchCugCorporateData);
}

//Fetch CaseType Filter List

export function* caseTypesFetch(action) {
    let requestURL = `${CORE_API}/portfolio/filter/caseType`;
    try {
        const caseTypeData = yield call(request, requestURL, { method: 'GET', data: '', headers: HTTP_HEADERS });
        yield put(fetchCaseTypeSuccess(caseTypeData.data))
    }
    catch (err) {
        yield put(fetchCaseTypeFailure(err))
    }
}
export function* fetchCaseTypes() {
    yield takeLatest(FETCH_CASE_TYPE, caseTypesFetch);
}